<template>
  <div class="cameras-page">
    <section class="hero-section">
      <div class="hero-content">
        <h1 class="hero-title">Cameras</h1>
        <p class="hero-subtitle">Live video feeds from your security cameras.</p>
      </div>
    </section>

    <div v-if="loading" class="loading-state">Loading cameras…</div>
    <div v-else-if="error" class="error-state">Unable to load cameras.</div>
    <div v-else class="camera-grid">
      <div v-for="camera in cameras" :key="camera.id" class="camera-card">
        <div class="camera-header">
          <h3>{{ camera.name }}</h3>
          <span class="live-badge">Live</span>
        </div>
        <CameraPlayer :playlist-url="camera.playlistUrl" />
      </div>
    </div>
  </div>
</template>

<script>
import CameraPlayer from './CameraPlayer.vue'

export default {
  name: 'CamerasPage',
  components: { CameraPlayer },
  data() {
    return {
      cameras: [],
      loading: true,
      error: false
    }
  },
  mounted() {
    this.loadCameras()
  },
  methods: {
    loadCameras() {
      this.loading = true
      this.error = false
      this.axios.get(process.env.VUE_APP_BACK_URL + '/cameras')
        .then(res => {
          const data = res.data?.data || res.data || []
          this.cameras = Array.isArray(data) ? data : []
          this.loading = false
        })
        .catch(() => {
          this.cameras = []
          this.error = true
          this.loading = false
        })
    }
  }
}
</script>

<style scoped>
.cameras-page {
  max-width: 1200px;
}

.hero-section {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 24px;
  margin-bottom: 28px;
  padding: 28px 32px;
  border-radius: var(--radius);
  background:
      linear-gradient(135deg, rgba(0, 212, 255, 0.08), rgba(0, 102, 255, 0.04)),
      var(--surface);
  border: 1px solid var(--border);
  box-shadow: var(--shadow);
}

.hero-title {
  font-family: var(--font-display);
  font-size: 2rem;
  font-weight: 700;
  margin: 0 0 8px;
  letter-spacing: 0.02em;
}

.hero-subtitle {
  color: var(--text-secondary);
  margin: 0;
  max-width: 480px;
  line-height: 1.5;
}

.loading-state,
.error-state {
  padding: 32px;
  text-align: center;
  color: var(--text-secondary);
  background: var(--surface);
  border: 1px solid var(--border);
  border-radius: var(--radius);
}

.error-state {
  color: var(--danger);
  background: var(--danger-bg);
}

.camera-grid {
  display: grid;
  grid-template-columns: repeat(auto-fill, minmax(480px, 1fr));
  gap: 24px;
}

.camera-card {
  border-radius: var(--radius);
  background: var(--surface);
  border: 1px solid var(--border);
  overflow: hidden;
}

.camera-header {
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 18px 22px;
  border-bottom: 1px solid var(--border);
}

.camera-header h3 {
  font-family: var(--font-display);
  font-size: 1.05rem;
  font-weight: 600;
  margin: 0;
}

.live-badge {
  padding: 4px 10px;
  border-radius: 20px;
  background: rgba(0, 230, 118, 0.1);
  color: var(--success);
  font-size: 0.7rem;
  font-weight: 700;
  text-transform: uppercase;
  letter-spacing: 0.08em;
}

@media (max-width: 640px) {
  .camera-grid {
    grid-template-columns: 1fr;
  }
}
</style>
